module.exports = __webpack_public_path__ + "static/media/growpartner_logo.b819e726.png";